import script from "./GeneralHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneralHeader.vue?vue&type=script&setup=true&lang=ts"

import "./GeneralHeader.vue?vue&type=style&index=0&id=7d0a16fd&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d0a16fd"]])

export default __exports__